import { createContext, useContext } from 'react'
import { useBoardState } from '../store/context'

export const SettingsProject = createContext<string | null>(null)
/** Every project section follows the sheet's address, independently of the page under it. */
export function useSettingsProject() {
  const id = useContext(SettingsProject)
  const { projects } = useBoardState()
  return id === null ? undefined : projects.get(id)
}
